<app-page-container id="terms-container">
    <app-terms-text [termType]="termType"></app-terms-text>
</app-page-container>
